import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { siteInfo } from '@/mocks/site';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20geometric%20gradient%20background%20with%20soft%20overlapping%20circles%20in%20coral%20and%20amber%20tones%2C%20minimalist%20modern%20design%2C%20smooth%20flowing%20shapes%2C%20clean%20aesthetic%2C%20digital%20atmosphere%2C%20warm%20inviting%20feeling%2C%20no%20text%20no%20people&width=1800&height=900&seq=hero-bg-gpoint&orientation=landscape"
          alt="g点网"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-6 leading-tight">
            {t('heroTitle')}
          </h1>
          <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-10 leading-relaxed">
            {t('heroSubtitle')}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/usage-guide"
              className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              {t('heroCta')}
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/about"
              className="px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full text-sm font-semibold hover:bg-background-50/25 transition-all whitespace-nowrap cursor-pointer"
            >
              {t('heroCtaSecondary')}
            </Link>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 mt-16 max-w-3xl mx-auto">
            {[
              { value: siteInfo.stats.users, label: t('statsUsers') },
              { value: siteInfo.stats.articles, label: t('statsArticles') },
              { value: siteInfo.stats.satisfaction, label: t('statsSatisfaction') },
              { value: siteInfo.stats.years, label: t('statsYears') },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400">{stat.value}</div>
                <div className="text-xs md:text-sm text-background-50/60 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}